import { render } from "./vehicle-search-results-component.vue?vue&type=template&id=6f448ec4"
import script from "./vehicle-search-results-component.vue?vue&type=script&lang=js"
export * from "./vehicle-search-results-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__